import { render } from "./clubSubscriptionConfirmed.vue?vue&type=template&id=311683fb&ts=true"
import script from "./clubSubscriptionConfirmed.vue?vue&type=script&lang=ts"
export * from "./clubSubscriptionConfirmed.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\projects\\Auraclub\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__